module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9n7n4n-04e7871a622a09e7cc01b75505f65ee7.svg";